import { CSTContract } from 'libs/data/contracts'
import { useAccount, useChainId } from 'wagmi'

import useRead from './useRead'

const useCSTClaimable = (writing) => {
  const account = useAccount()
  const chainId = useChainId()

  const validate = (value: unknown): value is bigint => typeof value === 'bigint'

  return useRead({
    contract:
      process.env.NEXT_PUBLIC_ENV == 'development'
        ? '0xBf51d5fE277cCbB53B795BDaD6de2496Cbc8024F'
        : (CSTContract.address as `0x${string}`),
    abi: CSTContract.abi,
    functionName: 'claimable',
    account: account.address,
    validate,
    enabled: chainId === parseInt(process.env.NEXT_PUBLIC_PULSECHAIN),
    writing: writing,
  })
}

export default useCSTClaimable
